export default __webpack_public_path__ + "static/media/84.acb901de.jpeg";